import { IClassname } from '@/lib/shared/model/classname';

export const Butler = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.26294 30.6848C3.26131 28.7053 3.72174 26.7528 4.60759 24.9826C5.49346 23.2124 6.78028 21.6735 8.36567 20.4883"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.36572 20.4883L11.3228 30.5455"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.6343 20.4883L20.6785 30.5365"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.9897 26.4702C15.7251 26.4702 15.5105 26.2556 15.5105 25.9909C15.5105 25.7263 15.7251 25.5117 15.9897 25.5117"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M15.9897 26.4702C16.2544 26.4702 16.469 26.2556 16.469 25.9909C16.469 25.7263 16.2544 25.5117 15.9897 25.5117"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M16.0102 30.3891C15.7456 30.3891 15.531 30.1745 15.531 29.9099C15.531 29.6452 15.7456 29.4307 16.0102 29.4307"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M16.0103 30.3891C16.2749 30.3891 16.4895 30.1745 16.4895 29.9099C16.4895 29.6452 16.2749 29.4307 16.0103 29.4307"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M23.6343 20.4883C25.2197 21.6735 26.5065 23.2124 27.3924 24.9826C28.2782 26.7528 28.7387 28.7053 28.737 30.6848"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.7392 19.4222L15.8057 20.2503L13.8735 19.4222C13.6749 19.337 13.4582 19.3024 13.2429 19.3215C13.0276 19.3407 12.8204 19.4129 12.6399 19.5319C12.4594 19.6509 12.3113 19.8126 12.2087 20.0029C12.1062 20.1933 12.0525 20.4061 12.0525 20.6222V21.8784C12.0525 22.0945 12.1062 22.3073 12.2087 22.4976C12.3113 22.688 12.4594 22.8497 12.6399 22.9687C12.8204 23.0877 13.0276 23.1599 13.2429 23.1791C13.4582 23.1982 13.6749 23.1636 13.8735 23.0784L15.8057 22.2503L17.7392 23.0784C17.9379 23.1636 18.1545 23.1982 18.3699 23.1791C18.5852 23.1599 18.7923 23.0877 18.9728 22.9687C19.1533 22.8497 19.3015 22.688 19.4039 22.4976C19.5066 22.3073 19.5602 22.0945 19.5602 21.8784V20.6222C19.5602 20.4061 19.5066 20.1933 19.4039 20.0029C19.3015 19.8126 19.1533 19.6509 18.9728 19.5319C18.7923 19.4129 18.5852 19.3407 18.3699 19.3215C18.1545 19.3024 17.9379 19.337 17.7392 19.4222Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.562 23.5654L24.0151 27.3174L24.2234 30.5365"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.55298 23.5654L8.09987 27.3174L7.89157 30.5365"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.715 13.3164C17.2207 13.6879 16.6191 13.8888 16.0007 13.8888C15.3823 13.8888 14.7807 13.6879 14.2864 13.3164"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.6832 10.8118C13.5068 10.8118 13.3638 10.6688 13.3638 10.4923C13.3638 10.3159 13.5068 10.1729 13.6832 10.1729"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M13.6831 10.8118C13.8596 10.8118 14.0026 10.6688 14.0026 10.4923C14.0026 10.3159 13.8596 10.1729 13.6831 10.1729"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M18.2875 10.8118C18.111 10.8118 17.968 10.6688 17.968 10.4923C17.968 10.3159 18.111 10.1729 18.2875 10.1729"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M18.2874 10.8118C18.4638 10.8118 18.6068 10.6688 18.6068 10.4923C18.6068 10.3159 18.4638 10.1729 18.2874 10.1729"
        stroke="#22364A"
        strokeWidth="1.33"
      />
      <path
        d="M22.8586 8.17273C22.8586 6.35406 22.1362 4.60988 20.8501 3.32389C19.5642 2.0379 17.8201 1.31543 16.0013 1.31543C14.1827 1.31543 12.4385 2.0379 11.1525 3.32389C9.8665 4.60988 9.14404 6.35406 9.14404 8.17273V10.4589C9.14404 12.2776 9.8665 14.0218 11.1525 15.3077C12.4385 16.5938 14.1827 17.3162 16.0013 17.3162C17.8201 17.3162 19.5642 16.5938 20.8501 15.3077C22.1362 14.0218 22.8586 12.2776 22.8586 10.4589V8.17273Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.8585 8.17291H20.5723C19.0554 8.17291 15.9348 8.55629 13.715 5.88672C13.1503 6.55953 12.4524 7.10809 11.6653 7.49781C10.8781 7.88755 10.0187 8.11001 9.14136 8.15119"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
